import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import WebUI1440Articles from 'components/Web_User_Interface/1440p_Series/Features/IntroWebUIFeatures1440';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü :: INSTAR 2k+ (WQHD) Web User Interface' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ändern Sie die Sprache der Web-Benutzeroberfläche, führen Sie einen Neustart oder Reset durch oder laden Sie ein Firmware- und Web-UI-Update auf Ihre Kamera.' image='/images/Search/QI_SearchThumb_WebUI_1440p.png' twitter='/images/Search/QI_SearchThumb_WebUI_1440p.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/' crumbLabel="Features Menu" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <WebUI1440Articles mdxType="WebUI1440Articles" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      